module.exports = __webpack_public_path__ + "img/card.c29c74c9.svg";